export const applySampleBoxInfoAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }